// 该页面专门用于创建整个项目的路由器
import { isDev } from '@/config/dev'
import { addPoint } from '@/bll/point'
import { createRouter, createWebHashHistory } from 'vue-router'

const modules = import.meta.globEager('./src/*.js')

// 异常页面
const error = () => import('../pages/error/error.vue')

const defaultRouter = [
  {
    path: '/error/error',
    component: error,
    name: 'error'
  },
  {
    path: '/',
    redirect: '/applicationCenter/index/undefined'
  }
]

/**自动导入 src/*.js中的路由信息 */
export const routes = [...defaultRouter]

/**开发环境，自动导入 dev/*.js中的路由 */
if (isDev()) {
  const devs = import.meta.globEager('./dev/*.js')
  for (const path in devs) {
    routes.push(...devs[path].default)
  }
}

for (const path in modules) {
  routes.push(...modules[path].default)
}

// 创建并暴露一个路由器
export const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// router.afterEach((to) => {
//   console.log('router.afterEach', to)
//   addPoint({ title: to.meta.title })
// })

export * from './link'
